import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "input-row" }
const _hoisted_2 = { class: "input-wr" }
const _hoisted_3 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_4 = { class: "input-row" }
const _hoisted_5 = { class: "input-wr" }
const _hoisted_6 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_7 = { class: "input-wr" }
const _hoisted_8 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_9 = { class: "input-row" }
const _hoisted_10 = { class: "input-wr" }
const _hoisted_11 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_12 = { class: "input-wr" }
const _hoisted_13 = ["value", "onChange"]
const _hoisted_14 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_15 = { class: "input-row" }
const _hoisted_16 = { class: "input-wr" }
const _hoisted_17 = { class: "input-row" }
const _hoisted_18 = { class: "input-wr" }
const _hoisted_19 = { class: "input dropdown-input" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "input-wr builder-wr" }
const _hoisted_22 = { class: "toggle-block" }
const _hoisted_23 = { class: "input-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "dashboard-header" }, [
      _createElementVNode("h2", { class: "title-main" }, "Create Lot")
    ], -1)),
    _createElementVNode("form", {
      class: "default-form",
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Lot Number", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.title.$error }]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.title) = $event)),
            type: "text",
            placeholder: "Lot Number"
          }, null, 2), [
            [
              _vModelText,
              $setup.form.title,
              void 0,
              { trim: true }
            ]
          ]),
          ($setup.v$.title.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.v$.title.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label" }, "Block Width", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.blockWidth.$error }]),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.blockWidth) = $event)),
            type: "number",
            placeholder: "Block Width"
          }, null, 2), [
            [_vModelText, $setup.form.blockWidth]
          ]),
          ($setup.v$.blockWidth.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.v$.blockWidth.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label" }, "Block Depth", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.blockDepth.$error }]),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.blockDepth) = $event)),
            type: "number",
            placeholder: "Block Depth"
          }, null, 2), [
            [_vModelText, $setup.form.blockDepth]
          ]),
          ($setup.v$.blockDepth.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($setup.v$.blockDepth.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label" }, "Size", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.size.$error }]),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.size) = $event)),
            type: "number",
            placeholder: "Size"
          }, null, 2), [
            [_vModelText, $setup.form.size]
          ]),
          ($setup.v$.size.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.v$.size.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "label" }, "Price", -1)),
          _createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.price.$error }]),
            value: $setup.formatPriceTrim($setup.form?.price),
            onChange: (e) => $setup.updatePriceInput(e, $setup.form, 'price'),
            type: "text",
            placeholder: "Price"
          }, null, 42, _hoisted_13),
          ($setup.v$.price.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($setup.v$.price.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label" }, "Street Name", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.streetName) = $event)),
            type: "text",
            placeholder: "Street Name"
          }, null, 512), [
            [
              _vModelText,
              $setup.form.streetName,
              void 0,
              { trim: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _cache[17] || (_cache[17] = _createElementVNode("label", { class: "label" }, "Status", -1)),
          _createVNode($setup["DropDown"], null, {
            control: _withCtx(() => [
              _createElementVNode("button", _hoisted_19, _toDisplayString($setup.form.status), 1)
            ]),
            dropdown: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.lotStatuses, (item) => {
                  return _createElementVNode("li", {
                    onClick: ($event: any) => ($setup.changeStatus(item))
                  }, _toDisplayString(item), 9, _hoisted_20)
                }), 64))
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode($setup["ToggleButton"], {
              modelValue: $setup.form.isBuildersEnabled,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.isBuildersEnabled) = $event)),
              label: "Home & Land package",
              additionalClass: 'large',
              labelBold: 'toggle-title-font bold'
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("button", {
            class: "button default primary manage-builder",
            type: "button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.isSelectBuildersModalOpen = true))
          }, "Manage Builders")
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("button", {
          class: "button default outlined cancel-btn",
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.router.go(-1))),
          type: "button"
        }, "Cancel"),
        _createElementVNode("button", {
          class: "button default primary create-btn",
          onClick: $setup.createLot,
          type: "button"
        }, "Create")
      ])
    ], 32),
    _createVNode($setup["SelectBuildersLotModal"], {
      isOpen: $setup.isSelectBuildersModalOpen,
      builders: $setup.builders,
      onSave: _cache[9] || (_cache[9] = ($event: any) => ($setup.form.builders = $event)),
      onClose: _cache[10] || (_cache[10] = ($event: any) => ($setup.isSelectBuildersModalOpen = false))
    }, null, 8, ["isOpen", "builders"])
  ], 64))
}